"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTokenExpiration = void 0;
const handleLogout_1 = require("./handleLogout");
const REFRESH_WINDOW_MS = 5 * 60 * 1000; // 5 minutes
const RETRY_DELAY_MS = 3000;
let refreshInFlight = false;
/**
 * Checks whether the current access token is expired or expiring soon
 * and attempts a silent refresh before falling back to logout.
 *
 * Improvements over the old AuthUtils version:
 *  - Expired tokens try signinSilent() first instead of logging out immediately
 *  - One automatic retry after RETRY_DELAY_MS before giving up
 *  - In-flight guard prevents duplicate concurrent refresh attempts
 */
const handleTokenExpiration = (auth) => {
    if (!auth.user?.expires_at)
        return;
    if (refreshInFlight)
        return;
    const nowMs = Date.now();
    const expiresAtMs = auth.user.expires_at * 1000;
    const timeUntilExpiry = expiresAtMs - nowMs;
    if (timeUntilExpiry > REFRESH_WINDOW_MS)
        return;
    refreshInFlight = true;
    auth
        .signinSilent()
        .then(() => {
        refreshInFlight = false;
    })
        .catch(() => {
        // Retry once after a short delay to handle transient network issues
        setTimeout(() => {
            auth
                .signinSilent()
                .then(() => {
                refreshInFlight = false;
            })
                .catch(() => {
                refreshInFlight = false;
                (0, handleLogout_1.handleLogout)(auth);
            });
        }, RETRY_DELAY_MS);
    });
};
exports.handleTokenExpiration = handleTokenExpiration;
